<template>
    <v-app>
        <v-overlay :value="loading">
            <v-sheet
                justify-center
                align-center
                outlined
                color="transparent">
                <v-progress-circular
                    indeterminate :size="50">
                </v-progress-circular>
            </v-sheet>
        </v-overlay>
    </v-app>
</template>

<script>
import { getTokenRequest } from "@/services";
import router from "@/router";
export default {
    name: 'RedirectAndGetToken',

    data() {
        return {
            msg: 'loading page',
            loading: false
        }
    },

    methods: {
        async getToken () {
            let token = this.$route.query?.token
            if (token) token = token.replaceAll(' ', '+')
            const formData = { token: token }

            this.loading = true
            const res = await getTokenRequest(formData)
            if (res && res.data && res.data.status && res.data.status.code === 0) {
                if (res.data.data?.roleList?.includes('ROLE_ADMIN')) {
                    localStorage.setItem('username', res.data.data.username)
                    localStorage.setItem('Token', res.data.data.token)
                    localStorage.setItem('AppUrl', JSON.stringify(res.data.data.appUrl))
                    localStorage.setItem('Permission', JSON.stringify(res.data.data.permission))
                    localStorage.setItem('RoleList', JSON.stringify(res.data.data.roleList))
                    localStorage.setItem('currentRole', res.data.data.currentRole)
                    localStorage.setItem('username', res.data.data.username)
                    router.push({ path: '/' })
                } else {
                    localStorage.clear()
                    this.$router.push({ path: 'error' })
                }
            } else {
                localStorage.clear()
                this.$router.push({ path: 'error' })
            }
            this.loading = false
        }
    },

    async mounted () {
        await this.getToken()
    }

}
</script>
